import axios from "../AxiosInterCeptor/AxiosInterCeptor";

/**
 * Server Control (super admin) — the backend's /serverControl routes. The backend talks to the control agent on the
 * automation server; this file never calls that server itself. Never throws: always { error, message, data }.
 */
const URL = process.env.React_App_BaseUrl;
const BASE = () => `${URL}/serverControl`;

const NO_RESPONSE = "No answer from the server. Please check your connection and try again";

const settle = (request) =>
  request
    .then((response) => {
      const body = response && response.data;
      return body && typeof body === "object" ? body : { error: true, message: "Unexpected answer from the server" };
    })
    .catch((error) => {
      if (error && error.response) {
        const body = error.response.data || {};
        return { error: true, message: body.message || `The server answered ${error.response.status}` };
      }
      return { error: true, noResponse: true, message: NO_RESPONSE };
    });

export const getServerOverview = () => settle(axios.get(`${BASE()}/overview`));
/** action: "start" | "stop" | "restart" | "cancel"; force skips waiting for the running windows. */
export const runServerAction = (action, { force = false } = {}) => settle(axios.post(`${BASE()}/action`, { action, force }));
export const getServerLogs = (lines = 200) => settle(axios.get(`${BASE()}/logs`, { params: { lines } }));
export const getServerEnv = () => settle(axios.get(`${BASE()}/env`));
/** Stop ONE running window = Hold (it stops at its next safe step and the policy goes on hold). */
export const stopServerWindow = (policyId) => settle(axios.post(`${BASE()}/windows/${policyId}/stop`));
